import {
  INICIA_NOTIFICACAO,
  NOVO_NOTIFICACAO,
  BUSCA_NOTIFICACAO_EDICAO,
  CANCELA_EDICAO,
  INICIO_NOTIFICACAO_SUCESSO,
  SALVA_NOTIFICACAO_SUCESSO,
  REMOVE_NOTIFICACAO_SUCESSO,
  BUSCA_NOTIFICACAO_EDICAO_SUCESSO,
  NOTIFICACAO_ALTERACAO_DATA,
  INIT_URL,
  HIDE_MESSAGE,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  ON_SHOW_ERROR_MESSAGE,
  SHOW_MESSAGE,
  ALTERACAO_CAMPO,
  ALTERACAO_COMBO,
  ALTERACAO_DATEPICKER,
  NOTIFICACAO_ALTERACAO_CHECK,
  APLICA_FILTRO,
  LISTA_NOTIFICACAO,
  LISTA_NOTIFICACAO_SUCESSO,
  LIMPAR_NOTIFICACAO,
  SALVA_NOTIFICACAO,
  SETAR_IMAGEM_NOTIFICACAO,
  ATUALIZA_NOTIFICACAO,
  NOTIFICACAO_LISTA_ESCOLAS_SUCESSO,
  NOTIFICACAO_LISTA_CATEGORIAS_SUCESSO,
  NOTIFICACAO_LISTA_TURMAS_SUCESSO
} from "constants/ActionTypes";
import { preparaListaParaCombo } from 'luxFw/transformations/Common';
import moment from 'moment';

const INIT_STATE = {
  // Configuração da Grid
  colunasGrid: [
    { titulo: 'Título', propriedadeApi: 'titulo', alinhamento: 'left' },
    { titulo: 'Categoria', propriedadeApi: 'nomeCategoria', alinhamento: 'left' },
    { titulo: 'Último Envio', propriedadeApi: 'ultimoEnvio', alinhamento: 'left' },
    { titulo: 'Envio Pendente', propriedadeApi: 'pendente', alinhamento: 'left' },
    { titulo: 'Enviado', propriedadeApi: 'enviado', alinhamento: 'left' },
    { titulo: 'Com Falha', propriedadeApi: 'falhou', alinhamento: 'left' },
    { titulo: 'Lido', propriedadeApi: 'lido', alinhamento: 'left' },
  ],
  // Propriedades Globais
  loader: false,
  alertMessage: '',
  showMessageSuccess: false,
  showMessageError: false,
  edicao: false,
  carregandoLista: true,
  listGrid: [],
  listGridComFiltro: [],
  textoFiltro: '',
  listaCategorias: [],
  listaEscolas: [],
  urlImagem: null,
  enviarDeImediato: false,
  id:0,
  edicao: true,
  titulo: null,
  subtitulo: null,
  corpo: null,
  corpoHtml: null,
  urlImagem: null,
  idCategoria: null,
  ultimosEnvios: [],
  alteraFoto: false,
  idCliente: 0,
  idsEscola: [
  ],
  idsTurma: [
  ],
  enviarDeImediato: true,
  dataHoraEnvio: null,
  // Filtros
  nomeAlunoFiltro: ''
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INICIA_NOTIFICACAO: {
      return {
        ...state,
        edicao: false,
        loader: true,
        carregandoLista: true,
        textoFiltro: '',
      }
    }
    case SETAR_IMAGEM_NOTIFICACAO: {
    
        var retorno = action.payload;
        return {
        ...state,
        alteraFoto: true,
        urlImagem: retorno.imagem,
        }
    }
    case NOVO_NOTIFICACAO: {
      return {
        ...state,
        id:0,
        edicao: true,
        alteraFoto: false,
        titulo: null,
        subtitulo: null,
        corpo: null,
        corpoHtml: null,
        urlImagem: null,
        idCategoria: null,
        idCliente: 0,
        ultimosEnvios: [],
        idsEscola: [
        ],
        idsTurma: [
        ],
        enviarDeImediato: true,
        dataHoraEnvio: null
      }
    }
    case SALVA_NOTIFICACAO: {
      return {
        ...state,
        loader: true,
      }
    }
    case NOTIFICACAO_LISTA_CATEGORIAS_SUCESSO: {
      const retorno = action.payload;
        return {
        ...state,
        listaCategorias:  preparaListaParaCombo(retorno, "id", "nome") || []
        };
    }
    case NOTIFICACAO_LISTA_ESCOLAS_SUCESSO: {
      const retorno = action.payload;
        return {
        ...state,
        listaEscolas:  preparaListaParaCombo(retorno, "id", "nome") || []
        };
    }
    case NOTIFICACAO_LISTA_TURMAS_SUCESSO: {
      const retorno = action.payload;

      return {
        ...state,
        listaTurmas: preparaListaParaCombo(retorno, "Id", "Nome") || []
      }
    }
    case ATUALIZA_NOTIFICACAO: {
      return {
        ...state,
        loader: true,
      }
    }
    case CANCELA_EDICAO: {
      return {
        ...state,
        edicao: false,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
        loader: false
      }
    }
    case BUSCA_NOTIFICACAO_EDICAO: {
      return {
        ...state,
        loader: true,
      }
    }
    case INICIO_NOTIFICACAO_SUCESSO: {
      const retorno = action.payload;
      // Algumas APIs retornam a lista sob a chave 'aluno' (singular) e outras sob 'alunos' (plural).
      // Para garantir compatibilidade, aceitamos ambas e também o próprio payload como lista.
      const lista = retorno || [];
      return {
        ...state,
        loader: false,
        carregandoLista: false,
        listGrid: lista,
        listGridComFiltro: lista
      }
    }
    case SALVA_NOTIFICACAO_SUCESSO: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageSuccess: true,
        edicao: false
      }
    }
    case REMOVE_NOTIFICACAO_SUCESSO: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageSuccess: true,
        edicao: false
      }
    }
    case LISTA_NOTIFICACAO: {
      return {
        ...state,
        loader: true,
      }
    }
    case APLICA_FILTRO: {
      const texto = action.payload || '';
      return {
        ...state,
        textoFiltro: texto
      }
    }
    case LISTA_NOTIFICACAO_SUCESSO: {
      const retorno = action.payload;
      return {
        ...state,
        loader: false,
        listGrid: retorno.aluno,
        listGridComFiltro: retorno.aluno,
      }
    }
    case LIMPAR_NOTIFICACAO: {
      return {
        ...state,
        nomeAlunoFiltro: '',
        textoFiltro: ''
      }
    }
    case BUSCA_NOTIFICACAO_EDICAO_SUCESSO: {
      var retorno = action.payload;
      // Em alguns cenários o backend retorna o aluno dentro de uma propriedade 'aluno'.
      // Normalizamos aqui para que o formulário receba o objeto do aluno diretamente.
      var base =  retorno;
      // Ajuste: garantir que responsaveis unificado esteja disponível para o formulário
      // O container/form mapeia responsaveis -> responsaveis/autorizados locais
      return {
        ...state,
        edicao: true,
        loader: false,
        ...base,
        enviarDeImediato: base.dataHoraEnvio === null,
        dataHoraEnvio: base.dataHoraEnvio ? moment(base.dataHoraEnvio) : moment(),
        id: base.id || base.Id || 0,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false

      }
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      }
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
        loader: false
      }
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      }
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      }
    }
    case ON_SHOW_ERROR_MESSAGE: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageError: true,
        edicao: false
      }
    }
    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessageError: true,
        loader: false
      }
    }
    case ALTERACAO_CAMPO: {
      return {
        ...state,
        [action.payload.target.name]: action?.payload?.target?.value,
      }
    }
    case ALTERACAO_COMBO: {
      return {
        ...state,
        [action.payload.nomeCombo]: action.payload.valor,
      }
    }
    case NOTIFICACAO_ALTERACAO_CHECK: {
      var retorno = action.payload;
      return {
        ...state,
        enviarDeImediato: retorno.valor
      }
    }
    case ALTERACAO_DATEPICKER: {
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      }
    }

    case NOTIFICACAO_ALTERACAO_DATA: {
      return {
        ...state,
        [action.payload.name]: action.payload.date,
      }
    }
    default:
      return state;
  }
}
